var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFlipBackward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63805 3.80482C5.8984 3.54447 5.8984 3.12236 5.63805 2.86201C5.3777 2.60166 4.95559 2.60166 4.69524 2.86201L2.02858 5.52868C1.76823 5.78903 1.76823 6.21114 2.02858 6.47149L4.69524 9.13815C4.95559 9.3985 5.3777 9.3985 5.63805 9.13815C5.8984 8.8778 5.8984 8.45569 5.63805 8.19534L4.10946 6.66675H11.5C12.7886 6.66675 13.8333 7.71142 13.8333 9.00008C13.8333 10.2887 12.7886 11.3334 11.5 11.3334H8.49998C8.13179 11.3334 7.83331 11.6319 7.83331 12.0001C7.83331 12.3683 8.13179 12.6667 8.49998 12.6667H11.5C13.525 12.6667 15.1666 11.0251 15.1666 9.00008C15.1666 6.97504 13.525 5.33341 11.5 5.33341H4.10946L5.63805 3.80482Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlipBackward);
export default __webpack_public_path__ + "static/media/ic_flip_backward.4889c2c37afc5bea29288e6e81dff66d.svg";
export { ForwardRef as ReactComponent };